/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_ActivationInputs */

const en_offline_activation = /** @type {(inputs: Offline_ActivationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline Activation`)
};

const fr_offline_activation = /** @type {(inputs: Offline_ActivationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activation hors ligne`)
};

const de_offline_activation = /** @type {(inputs: Offline_ActivationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline-Aktivierung`)
};

const it_offline_activation = /** @type {(inputs: Offline_ActivationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attivazione offline`)
};

const ru_offline_activation = /** @type {(inputs: Offline_ActivationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автономная активация`)
};

const es_offline_activation = /** @type {(inputs: Offline_ActivationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activación sin conexión`)
};

const zh_cn2_offline_activation = /** @type {(inputs: Offline_ActivationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`离线激活`)
};

const ja_offline_activation = /** @type {(inputs: Offline_ActivationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オフラインアクティベーション`)
};

const hi_offline_activation = /** @type {(inputs: Offline_ActivationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑफ़लाइन सक्रियण`)
};

const pt_pt2_offline_activation = /** @type {(inputs: Offline_ActivationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativação offline`)
};

/**
* | output |
* | --- |
* | "Offline Activation" |
*
* @param {Offline_ActivationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_activation = /** @type {((inputs?: Offline_ActivationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_ActivationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_activation(inputs)
	if (locale === "de") return de_offline_activation(inputs)
	if (locale === "it") return it_offline_activation(inputs)
	if (locale === "ru") return ru_offline_activation(inputs)
	if (locale === "es") return es_offline_activation(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_activation(inputs)
	if (locale === "ja") return ja_offline_activation(inputs)
	if (locale === "hi") return hi_offline_activation(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_activation(inputs)
	return en_offline_activation(inputs)
});